import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { transferMatchingService } from '../../services/transferMatchingService';

const {
  FiCheck,
  FiEye,
  FiX,
  FiLoader,
  FiArrowRight
} = FiIcons;

export default function TransferMatchActions({
  match,
  onUpdated,
  onReview
}) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');

  const runAction = async (action) => {
    setIsProcessing(true);
    setError('');

    try {
      await action();
      onUpdated?.();
    } catch (actionError) {
      setError(actionError.message || 'Transfer match update failed.');
    } finally {
      setIsProcessing(false);
    }
  };

  if (!match) {
    return (
      <span className="text-[10px] font-medium text-slate-400">
        Unmatched
      </span>
    );
  }

  if (match.status === 'MATCHED') {
    return (
      <span className="inline-flex items-center gap-1 rounded-md bg-emerald-50 px-2 py-1 text-[10px] font-medium text-emerald-700">
        <SafeIcon icon={FiCheck} />
        Matched
      </span>
    );
  }

  if (match.status === 'IGNORED') {
    return (
      <span className="text-[10px] font-medium text-slate-400">
        Unmatched
      </span>
    );
  }

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-1.5">
        <span className="inline-flex items-center gap-1 rounded-md bg-amber-50 px-2 py-1 text-[10px] font-medium text-amber-700">
          <SafeIcon icon={FiArrowRight} />
          Match Found
        </span>

        <button
          type="button"
          onClick={() => runAction(() => transferMatchingService.confirmMatch(match.id))}
          disabled={isProcessing}
          className="rounded-md bg-emerald-600 px-2 py-1 text-[10px] font-medium text-white transition hover:bg-emerald-700 disabled:opacity-50"
        >
          {isProcessing ? <SafeIcon icon={FiLoader} className="animate-spin" /> : 'Confirm'}
        </button>

        <button
          type="button"
          onClick={() => onReview?.(match)}
          disabled={isProcessing}
          className="rounded-md border border-slate-200 bg-white px-2 py-1 text-[10px] font-medium text-slate-600 transition hover:bg-slate-50 disabled:opacity-50"
        >
          <SafeIcon icon={FiEye} className="mr-1 inline" />
          Review
        </button>

        <button
          type="button"
          onClick={() => runAction(() => transferMatchingService.ignoreMatch(match.id))}
          disabled={isProcessing}
          className="rounded-md border border-slate-200 bg-white px-2 py-1 text-[10px] font-medium text-slate-500 transition hover:bg-slate-50 disabled:opacity-50"
          title="Ignore transfer match"
          aria-label="Ignore transfer match"
        >
          <SafeIcon icon={FiX} />
        </button>
      </div>

      {error && (
        <p className="max-w-[220px] text-center text-[10px] text-rose-600">
          {error}
        </p>
      )}
    </div>
  );
}